<template>
  <div>
    <v-chip
      v-if="auth.set"
      class="ma-2 text-uppercase font-weight-bold"
      color="grey"
      label
      text-color="white"
      close
      close-icon="mdi-logout"
      @click:close="api.logout()"
    >
      <v-icon left>
        mdi-account-check
      </v-icon>
      {{ auth.name }}
    </v-chip>
  </div>
</template>

<script>
export default {
}
</script>